import { Outlet } from "react-router";
import { Header } from "./Header/Header";

import Col from 'react-bootstrap/Col';
import { Container } from "react-bootstrap";

/**
 * Main Layout Component for the app which will inherit Header and Sidebar component
 *
 * @returns {*}
 */
export const MainLayout = () => {
    return (
        <main className="mainContentBox">
            <div className="">
                <Col xs className="h-100">
                    <div className="d-flex flex-column h-100">
                        <Header />
                        <div className="main-cover">
                           
                                <Outlet />
                            
                        </div>
                    </div>
                </Col>
            </div>
        </main>
    );
};